import Image from "next/image";
import { PHOTO_HOVER_ZOOM } from "@/lib/card-styles";

/**
 * The logo well for an affiliate card. Deliberately NOT `ProfileLogoBadge`
 * (the gold-ringed circle on navy): that treatment means "an Easytiger
 * listing", and affiliate logos are mostly wide wordmarks that a circle crops.
 * So the logo fills the well edge to edge (`object-cover`, owner 2026-09-15,
 * like a pro photo) on a white tile, and a missing logo falls back to the
 * brand's initial. Uploads are 3:4 at 600 x 800 like pro photos, so the list
 * and grid wells show them whole; the chat well is 3:4 too.
 *
 * The caller owns the footprint (aspect, size, radius) through `className`.
 */
export default function AffiliateLogo({
  name,
  logo,
  sizes,
  className = "",
  initialClass = "text-3xl",
}: {
  name: string;
  logo: string | null;
  sizes: string;
  className?: string;
  /** Type size of the monogram fallback, scaled to the well. */
  initialClass?: string;
}) {
  return (
    // White behind a logo, not the tile grey: Safari cannot canvas-encode WebP,
    // so its uploads are JPEGs painted on white, and that white would show against
    // grey behind a transparent logo while Chrome's WebP uploads did not (review 2026-09-15).
    <div className={`relative flex items-center justify-center overflow-hidden border border-card-line ${logo ? "bg-white" : "bg-surface"} ${className}`}>
      {logo ? (
        <Image src={logo} alt="" fill sizes={sizes} className={`object-cover ${PHOTO_HOVER_ZOOM}`} />
      ) : (
        <span aria-hidden="true" className={`font-serif leading-none text-navy/40 ${initialClass}`}>
          {name.trim().slice(0, 1).toUpperCase()}
        </span>
      )}
    </div>
  );
}
